export default __webpack_public_path__ + "static/media/adventureasia.7809bf37.jpg";